import { supabase } from '../supabase';

export const playlistsService = {
  // Crear una nueva playlist
  async createPlaylist(userId, playlistData) {
    const { data, error } = await supabase
      .from('playlist')
      .insert({
        user_id: userId,
        name: playlistData.name,
        description: playlistData.description || null,
        is_public: playlistData.isPublic || false,
        image_url: playlistData.image || null,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  // Obtener todas las playlists de un usuario
  async getUserPlaylists(userId) {
    const { data, error } = await supabase
      .from('playlist')
      .select(`
        *,
        playlist_tracks (
          id,
          track_title,
          track_artist,
          track_image,
          track_preview_url,
          track_external_url,
          position,
          created_at
        )
      `)
      .eq('user_id', userId)
      .order('created_at', { ascending: false });

    if (error) throw error;

    // Transformar los datos al formato esperado por la app
    const playlists = data.map(playlist => ({
      id: playlist.id,
      name: playlist.name,
      description: playlist.description,
      image: playlist.image_url,
      isPublic: playlist.is_public,
      songs: playlist.playlist_tracks.map(track => {
        console.log('📖 Cargando canción desde BD:', {
          title: track.track_title,
          artist: track.track_artist,
          previewUrl: track.track_preview_url,
          hasPreview: !!track.track_preview_url
        });
        return {
          id: track.id, // ID de la canción en la BD
          title: track.track_title,
          artist: track.track_artist,
          image: track.track_image,
          previewUrl: track.track_preview_url,
          spotifyUrl: track.track_external_url,
          position: track.position
        };
      }),
      created_at: playlist.created_at,
      updated_at: playlist.updated_at
    }));

    console.log('📚 Total de playlists cargadas:', playlists.length);
    return playlists;
  },

  // Agregar una canción a una playlist
  async addTrackToPlaylist(playlistId, songData) {
    console.log('📝 Guardando canción en BD:', {
      title: songData.title,
      artist: songData.artist,
      previewUrl: songData.previewUrl,
      hasPreview: !!songData.previewUrl
    });

    // Primero verificar cuántas canciones hay para determinar la posición
    const { count } = await supabase
      .from('playlist_tracks')
      .select('*', { count: 'exact', head: true })
      .eq('playlist_id', playlistId);

    const position = (count || 0) + 1;

    const { data, error } = await supabase
      .from('playlist_tracks')
      .insert({
        playlist_id: playlistId,
        track_title: songData.title,
        track_artist: songData.artist,
        track_image: songData.image || null,
        track_preview_url: songData.previewUrl || null,
        track_external_url: songData.spotifyUrl || null,
        position: position,
        created_at: new Date().toISOString()
      })
      .select()
      .single();

    if (error) throw error;

    // Actualizar updated_at de la playlist
    await supabase
      .from('playlist')
      .update({ updated_at: new Date().toISOString() })
      .eq('id', playlistId);

    return data;
  },

  // Eliminar una canción de una playlist
  async removeTrackFromPlaylist(playlistId, trackId) {
    const { error } = await supabase
      .from('playlist_tracks')
      .delete()
      .eq('id', trackId)
      .eq('playlist_id', playlistId);

    if (error) throw error;

    // Actualizar updated_at de la playlist
    await supabase
      .from('playlist')
      .update({ updated_at: new Date().toISOString() })
      .eq('id', playlistId);

    return true;
  },

  // Eliminar una playlist completa
  async deletePlaylist(playlistId, userId) {
    // Primero eliminar todas las canciones (cascade debería hacerlo automáticamente si está configurado)
    const { error: tracksError } = await supabase
      .from('playlist_tracks')
      .delete()
      .eq('playlist_id', playlistId);

    if (tracksError) throw tracksError;

    // Luego eliminar la playlist
    const { error: playlistError } = await supabase
      .from('playlist')
      .delete()
      .eq('id', playlistId)
      .eq('user_id', userId);

    if (playlistError) throw playlistError;

    return true;
  },

  // Actualizar información de una playlist
  async updatePlaylist(playlistId, userId, updates) {
    const { data, error } = await supabase
      .from('playlist')
      .update({
        name: updates.name,
        description: updates.description,
        is_public: updates.isPublic,
        image_url: updates.image,
        updated_at: new Date().toISOString()
      })
      .eq('id', playlistId)
      .eq('user_id', userId)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  // Verificar si una canción ya está en una playlist
  async isTrackInPlaylist(playlistId, trackTitle, trackArtist) {
    const { data, error } = await supabase
      .from('playlist_tracks')
      .select('id')
      .eq('playlist_id', playlistId)
      .eq('track_title', trackTitle)
      .eq('track_artist', trackArtist)
      .single();

    if (error && error.code !== 'PGRST116') throw error;
    return !!data;
  }
};
